import React from 'react';
import { useSelector } from 'react-redux';
import { useGetMembersQuery } from '../features/members/membersApi';
import { useGetProjectsQuery } from '../features/projects/projectsApi';
import SingleMember from './SingleMember';
import SingleProject from './SingleProject';

const Sidebar = () => {
  const {
    data: members,
    isError: isMembersFetchError,
    isLoading: isMembersFetchLoading,
  } = useGetMembersQuery();
  const {
    data: projects,
    isError: isProjectsFetchError,
    isLoading: isProjectsFetchLoading,
  } = useGetProjectsQuery();

  const { checked } = useSelector((state) => state.projects);

  // decide what to render
  let membersContent = null;
  let projectContent = null;

  if (isMembersFetchLoading && !isMembersFetchError) {
    membersContent = <p>Loading...</p>;
  }

  if (isProjectsFetchLoading && !isProjectsFetchError) {
    projectContent = <p>Loading...</p>;
  }

  if (isMembersFetchError && !isMembersFetchLoading) {
    membersContent = <p>There was an error</p>;
  }

  if (isProjectsFetchError && !isProjectsFetchLoading) {
    projectContent = <p>There was an error</p>;
  }

  if (!isMembersFetchError && !isMembersFetchLoading && members?.length === 0) {
    membersContent = <p>No Members Found</p>;
  }

  if (
    !isProjectsFetchError &&
    !isProjectsFetchLoading &&
    projects?.length === 0
  ) {
    projectContent = <p>No Projects Found</p>;
  }

  if (!isMembersFetchError && !isMembersFetchLoading && members?.length > 0) {
    membersContent = members.map((member) => (
      <SingleMember key={member.id} name={member.name} image={member.avatar} />
    ));
  }

  if (
    !isProjectsFetchError &&
    !isProjectsFetchLoading &&
    projects?.length > 0
  ) {
    projectContent = projects.map((project) => (
      <SingleProject
        key={project.id}
        checked={checked[project.id]}
        project={project}
      />
    ));
  }

  return (
    <div className="sidebar">
      <div>
        <h3 className="text-xl font-bold">Projects</h3>
        <div className="mt-3 space-y-4">{projectContent}</div>
      </div>

      <div className="mt-8">
        <h3 className="text-xl font-bold">Team Members</h3>
        <div className="mt-3 space-y-4">{membersContent}</div>
      </div>
    </div>
  );
};

export default Sidebar;
